export const environment = {
  service_engine_base_url: "https://dev-service-engine.steppke.oparco.de/",
  app_url: "https://dev-evaluation.steppke.oparco.de",
  production: false,
  app_name: "dev-evaluation-steppke",
  CNAME: "",
  Domain: "dev-evaluation.steppke.oparco.de",
  logto_endpoint: "https://tmusmu.logto.app/",
  logto_app_id: "b5rf52e2hfnn00hbtavr6",
  logto_redirect_uri: "https://dev-evaluation.steppke.oparco.de/admin-login",
  // logto_redirect_uri: "http://localhost:4200/admin-login",
  logto_api_resource: "https://dev-service-engine.steppke.oparco.de/",
};
